import { Component, HostListener, OnInit } from '@angular/core';
import { ClickResponse } from 'src/app/auth/click.response.model';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { FormControl, FormBuilder } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/auth/auth.service';
import { Router } from '@angular/router';
import { ExportToCsv } from 'export-to-csv';
import { ApplicationListApplicationTabFormModel } from './application-list-application-tab-form.model';
import { ApplicationListApplicationTabSearchTable } from './application-list-application-tab-search-table.model';
declare var $: any;

@Component({
    selector: 'app-application-list-application-tab',
    templateUrl: './application-list-application-tab.component.html',
    styleUrls: ['./application-list-application-tab.component.css']
})
export class ApplicationListApplicationTabComponent implements OnInit {

    public appId: any;

    public applications: any[] = [];
    public searchApplications: any[] = [];
    public numberOfElements = 0;
    public sliceNumber = 0;
    public sliceSize = 10;
    public totalElements = 0;
    public totalPages = 0;
    public slices: number[] = [];

    public selectedStatus: any = 'APPROVED';
    public industries: any[] = [];
    public salesPeople: any[] = [];
    public statesOfIncorporation: any[] = [];

    public searchForm: ApplicationListApplicationTabFormModel = new ApplicationListApplicationTabFormModel(this.formBuilder);

    public status: FormControl = new FormControl('All');

    public approvedCkb: FormControl = new FormControl(false);
    public declinedAbandonedCkb: FormControl = new FormControl(false);
    public contractsGeneratedCkb: FormControl = new FormControl(false);
    public contractsSignedAwaitingInvoiceCkb: FormControl = new FormControl(false);
    public vODRequiredCkb: FormControl = new FormControl(false);
    public fundedCkb: FormControl = new FormControl(false);

    public messageTitle = '';
    public messageMessageA = '';
    public messageMessageB = '';
    public messageMessageC = '';
    public messageMessageBClass = '';
    public dialogClass = '';
    public selectedApp: number = 0;
    public showVend = false;

    public documents: any[] = [];

    public steps: any;
    public selectedStep: any = [];
    public nextStepSelected: any;

    public selectedRow: number = -1;

    public applicationsSearched: boolean = false;

    public resultsTopOpen: boolean = false;
    public resultsBottomOpen: boolean = false;

    public statusFilterOpen: boolean = false;

    public stepFilter: boolean = false;

    public innerWidth: number = 0;

    showPreapprovalFilter = false;

    constructor(
        private connectionService: ConnectionService,
        private authService: AuthService,
        public router: Router,
        private formBuilder: FormBuilder) {
        const navigation = this.router.getCurrentNavigation();
        if (navigation.extras.state) {
            this.appId = navigation.extras.state.appId;
        }
    }

    ngOnInit() {
        this.innerWidth = window.innerWidth;
        this.showPreapprovalFilter = localStorage.getItem('logged_user') ? JSON.parse(localStorage.getItem('logged_user')).showPreapproval : false;
        this.getStep();
        this.getVendorSalesPeople().then(
            () => this.getStates().then(
                () => this.getNaics().then(
                    () => {
                        if (this.appId) {
                            this.loadApplications(0, this.sliceSize, this.appId).then(
                                () => this.selectedRow = 0
                            );
                        } else {
                            this.loadApplications(0, this.sliceSize);
                        }
                    }
                )
            )
        );

    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.innerWidth = window.innerWidth;
    }

    loadApplications(slice: number, elements: number, appId?: number) {
        return new Promise((resolve, reject) => {
            const postData = this.searchForm.encode();
            postData.vendorId = this.authService.getVendorId();
            postData.status = this.selectedStatus ? [this.selectedStatus] : undefined;
            postData.orderBy = '';
            postData.nextStatus = this.nextStepSelected;
            postData.sortUpDown = true;
            postData.appId = appId ? appId : undefined;
            postData.criteria = undefined;
            this.connectionService.postRequest(
                environment.gateway + 'v2/findApplications/' + slice + '/' + elements, postData,
                'application/json', 'sp_id=' + this.authService.getSalesPersonId())
                .subscribe(
                    (data: ClickResponse) => {
                        this.applications = [];
                        if (data.object && data.object.applications) {
                            data.object.applications.forEach((element: any) => {
                                this.applications.push(element);
                                if (this.applications[0]['showVendorName'] == true) { this.showVend = true; }
                            });
                        }

                        this.numberOfElements = data.object && data.object.numberOfElements ? data.object.numberOfElements : 0;
                        this.sliceNumber = data.object && data.object.sliceNumber ? data.object.sliceNumber : 0;
                        this.totalElements = data.object && data.object.totalElements ? data.object.totalElements : 0;
                        this.totalPages = data.object && data.object.totalPages ? data.object.totalPages : 0;
                        this.slices = Array.from(Array(this.totalPages), (x, index) => index + 1);
                        window.scroll(0, 0);

                        resolve(data);
                    },
                    (error: any) => {
                        console.log(error);
                        reject();
                    });
        });
    }

    getVendorSalesPeople() {
        return new Promise((resolve, reject) => {
            this.connectionService.postRequest(environment.gateway + 'vendor/salesperson/' + this.authService.getVendorId(), {},
                'application/json').subscribe(
                    (data: any) => {
                        this.salesPeople = data.object;
                        resolve(data);
                    },
                    (error: any) => {
                        this.salesPeople = [];
                        resolve(error);
                    }
                );
        });
    }

    onSliceClick(slice: number) {
        this.selectedRow = -1;
        this.loadApplications(slice, this.sliceSize);
    }

    onBackClick() {
        if (this.sliceNumber > 0) {
            this.selectedRow = -1;
            this.loadApplications(this.sliceNumber - 1, this.sliceSize);
        }
    }

    onNextClick() {
        if (this.sliceNumber < this.totalPages - 1) {
            this.selectedRow = -1;
            this.loadApplications(this.sliceNumber + 1, this.sliceSize);
        }
    }
    onLastClick(){
        if (this.sliceNumber < this.totalPages - 1) {
            this.selectedRow = -1;
            this.loadApplications(this.slices.length-1, this.sliceSize);
        }
    }
    onFirstClick(){
       
            this.selectedRow = -1;
            this.loadApplications(this.slices[0]-1, this.sliceSize);
        
    }


    onReloadSlice() {
        this.loadApplications(this.sliceNumber, this.sliceSize);
    }

    onSearchClick() {
        const postData = this.searchForm.encode();
        postData.vendorId = this.authService.getVendorId();
        postData.salesPersonId = this.authService.getSalesPersonId();

        this.connectionService.postRequest(
            environment.gateway + 'v2/filterApplication', postData, 'application/json')
            .subscribe(
                (data: ClickResponse) => {
                    this.applicationsSearched = true;
                    this.searchApplications = [];
                    if (data.object) {
                        data.object.forEach((element: any) => {
                            this.searchApplications.push(new ApplicationListApplicationTabSearchTable(element));
                        });
                    }
                },
                (error: any) => {
                    this.applicationsSearched = true;
                    console.log(error);
                });
    }

    onSearchCellClick(appId: number) {
        this.loadApplications(0, this.sliceSize, appId).then(
            () => this.selectedRow = 0
        )
    }

    onClearClick() {
        this.searchForm = new ApplicationListApplicationTabFormModel(this.formBuilder);
        this.searchApplications = [];
        this.applicationsSearched = false;
    }

    onCloseSearchModal() {
        this.loadApplications(0, this.sliceSize).then(
            () => this.selectedRow = -1
        );
    }

    onExportClick() {
        const csvExporter = new ExportToCsv({
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: true,
            title: 'applications',
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true
            // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
        });
        const data = [];
        this.applications.forEach((application: any) => {
            data.push(application.applicationTableData);
        });
        csvExporter.generateCsv(data);
    }

    openSearchModal() {
        this.applicationsSearched = false;
        this.searchApplications = [];
        this.searchForm = new ApplicationListApplicationTabFormModel(this.formBuilder);
        $('#searchApplicationsModal').modal({ backdrop: 'static', keyboard: false });
    }

    getStates() {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequestUnsecured(environment.gateway + 'utils/states', 'application/json').subscribe(
                (data: any) => {
                    this.statesOfIncorporation = data.object;
                    resolve(data);
                },
                (error: any) => {
                    resolve(error);
                }
            );
        });
    }

    getStep() {
        this.steps = [
            { code: "Default", name: "All" },
            { code: "Create_Contracts", name: "Create Contracts" },
            { code: "Submit_Invoice", name: "Submit Invoice" }
        ];
    }

    selectStep(id: any) {
        this.selectedRow = -1;
        this.selectedStatus = undefined;
        this.selectedStep = this.steps[id];
        this.nextStepSelected = [this.selectedStep.name];
        this.loadApplications(0, this.sliceSize);
    }


    getNaics() {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequestUnsecured(environment.gateway + 'utils/naics', 'application/json').subscribe(
                (data: any) => {
                    this.industries = data.object;
                    resolve(data);
                },
                (error: any) => {
                    resolve(error);
                }
            );
        });
    }

    onStatusCheckClick(value: any) {
        this.selectedRow = -1;
        this.nextStepSelected = undefined;
        this.selectedStep = [];
        this.selectedStatus = value;
        this.loadApplications(0, this.sliceSize);
    }

    onApplicationIdClick(appId: number) {
        this.router.navigateByUrl('/application/offers', { state: { applicationId: appId, generateOffers: false } });
    }

    onApplicationBusinessNameClick(appId: number) {
        this.router.navigateByUrl('/application/summary', { state: { applicationId: appId, generateOffers: false } });
    }

    onSelectionChange(event: any, appId: number) {
        console.log(event);
        switch (event.target.value) {
            case '1':
                this.resendContract(appId);
                break;
            case '2':
                this.selectedApp = appId;
                $('#uploadNachaModal').modal();
                break;
            default:
                break;
        }
    }

    resendContract(appId: number) {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequest(environment.gateway + 'docusign/' + appId + '/resend',
                'application/json').subscribe(
                    (data: any) => {
                        this.messageTitle = 'Contract sent';
                        this.messageMessageA = 'Your contract was successfully sent.';
                        this.messageMessageB = '';
                        this.messageMessageC = '';
                        this.messageMessageBClass = '';
                        this.dialogClass = 'w450';
                        $('#errorModalDialogActionMessage').modal();
                        resolve(data);
                    },
                    (error: any) => {
                        this.messageTitle = 'Sorry, we found a problem';
                        this.messageMessageA = 'Unfortunately we are unable to process your request at this moment.';
                        this.messageMessageB = error.error.msg;
                        this.messageMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
                        this.messageMessageBClass = 'mB20';
                        this.dialogClass = 'w600';
                        $('#errorModalDialogActionMessage').modal();
                        resolve(error);
                    }
                );
        });
    }

    onFileAdded(file: any) {
        this.documents = [];
        this.documents.push(file);
    }

    onUploadNachaFile() {
        return new Promise((resolve, reject) => {
            const nachaFile = [
                {
                    documentB: this.documents[0].file.data.substr(this.documents[0].file.data.indexOf(',') + 1),
                    name: this.documents[0].file.name
                }
            ];
            this.connectionService.postRequest(environment.gateway + 'save/ach/' + this.selectedApp, nachaFile,
                'application/json').subscribe(
                    (data: any) => {
                        this.messageTitle = 'NACHA file';
                        this.messageMessageA = 'Your NACHA file was successfully upload.';
                        this.messageMessageB = '';
                        this.messageMessageC = '';
                        this.messageMessageBClass = '';
                        this.dialogClass = 'w450';
                        $('#errorModalDialogActionMessage').modal();
                        this.documents = [];
                        resolve(data);
                    },
                    (error: any) => {
                        this.messageTitle = 'Sorry, we found a problem';
                        this.messageMessageA = 'Unfortunately we are unable to process your request at this moment.';
                        this.messageMessageB = error.error.msg;
                        this.messageMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
                        this.messageMessageBClass = 'mB20';
                        this.dialogClass = 'w600';
                        $('#errorModalDialogActionMessage').modal();
                        this.documents = [];
                        resolve(error);
                    }
                );
        });
    }

    toggleSelectedRow(rowId: number, appId: number) {
        if (this.selectedRow == rowId) {
            this.selectedRow = -1;
        } else {
            this.selectedRow = rowId;
        }
    }

    get summaryColAmount() {
        if (this.innerWidth < 992) {
            return 3;
        }
        else if (this.showVend) {
            return 8;
        } else {
            return 7;
        }
    }

    getOwnersNames(app: any) {
        let ownersNames = '';
        app.owners.forEach((owner: any) => {
            ownersNames += ', ' + owner.name;
        });

        return ownersNames.substr(1, ownersNames.length);
    }

    toggleResultsTopOpen() {
        this.resultsTopOpen = !this.resultsTopOpen;
    }

    toggleResultsBottomOpen() {
        this.resultsBottomOpen = !this.resultsBottomOpen;
    }

    loadNApplications(sliceSize: any) {
        this.sliceSize = sliceSize;
        this.loadApplications(0, this.sliceSize);
    }

    toggleStatusFilter() {
        this.statusFilterOpen = !this.statusFilterOpen;
    }

    toggleStepFilter() {
        this.stepFilter = !this.stepFilter;
    }

    getShowCurrentStatusRedIcon(app: any): boolean {
        return app.appSummary.processStatus.vodStatusProcess.customerRequiredFlag == 'RED' || app.appSummary.processStatus.dlStatusProcess.customerRequiredFlag == 'RED'
    }
}
